import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { selectGlobalDbnTaxonomyDomainsCreatedItem, selectGlobalDbnTaxonomyDomainsDeletedItem, selectGlobalDbnTaxonomyDomainsListItems, selectGlobalDbnTaxonomyDomainsUpdatedItem } from "../../../../redux/global-dbn-taxonomy-domains/selector";
import { globalDbnTaxonomyDomains } from "../../../../redux/global-dbn-taxonomy-domains/action";
import PageLoader from "../../../../components/PageLoader";
import { settings } from "../../../../redux/settings/actions";
import UploadCommonModal from "../../../../models/upload-common-modal";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { toast } from "react-toastify";
import Table from "../../../../common/components/table-manager/v1.1/table";

const GlobalShipXTaxonomyDomains = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const { getUploadModal } = useAppSelector(selectCurrent)
  const listGlobalDbnTaxonomyDomainData = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
  const createGlobalDbnTaxonomyDomainData = useSelector(selectGlobalDbnTaxonomyDomainsCreatedItem)
  const updateGlobalDbnTaxonomyDomainData = useSelector(selectGlobalDbnTaxonomyDomainsUpdatedItem)
  const deleteGlobalDbnTaxonomyDomainData = useSelector(selectGlobalDbnTaxonomyDomainsDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});
  const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text', },
      { field: 'IsSubDomain', headerName: 'Sub Domain', searchField: 'IsSubDomain', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
      { field: 'ParentDomainName', headerName: 'Parent Domain', searchField: 'ParentDomainName', sortable: true, filter: true, filterType: 'text' },
      { field: 'Code', headerName: 'Code', searchField: 'Code', sortable: true, filter: true, filterType: 'text', }
    ]);
  }

  const fetchGlobalDbnTaxonomyDomains = async () => {
    await dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomyDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`, entity: 'GlobalDbnTaxonomyDomains', jsonData:
      {
        "Context": {},
        "Records": [
          {
            "IsSubDomain": null,
            "ParentDomainId": 35//to get all records 
          }
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "GlobalDBNDomainId",
          "SortOrder": "desc",
        }
      }
    }))
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data.GlobalDBNDomainId}`)
  }

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column || data?.searchCriteriaList,
        FieldText: data?.column || data?.searchCriteriaList,
        FieldType: 'text',
        FilterOperatorId: data?.filterOperatorId || 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomyDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
      entity: 'globalDbnTaxonomyDomains',
      jsonData: {
        "Context": {},
        "Records": [
          {
            "IsSubDomain": null ,
             "ParentDomainId": 35
          }
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "GlobalDBNDomainId",
          "SortOrder": "desc",
          "Searches": searchCriteria,
        }
      }
    }));
  }

  const handleDownloadTemplate = () => {
    const fileUrl = require('../../../../assets/data/domain_template.csv');
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "domain_template.csv"); // Optional: Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const additionButtons: any = [
    // {
    //   svg:
    //     <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24" className="mr-2">
    //       <title>Add Domain</title>
    //       <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
    //     </svg>,
    //   name: 'Domain',
    //   callback: () => handleAdd(),
    // },
    // {
    //   svg:
    //     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
    //       <title>Import Domains</title>
    //       <path d="M3.00012 14L3.23397 14.6626C4.14412 17.2413 4.5992 18.5307 5.63754 19.2654C6.67588 20 8.04322 20 10.7779 20H13.2224C15.957 20 17.3244 20 18.3627 19.2654C19.401 18.5307 19.8561 17.2413 20.7663 14.6626L21.0001 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    //       <path d="M12.0001 14V4M12.0001 14C11.2999 14 9.99165 12.0057 9.50012 11.5M12.0001 14C12.7003 14 14.0086 12.0057 14.5001 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    //     </svg>,
    //   // name: 'Domains',
    //   callback: () => handleUploadDomainClick(),
    // },
    // {
    //   svg:
    //     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none">
    //       <title>Download Template</title>
    //       <path d="M4 7C4.58984 7.60684 6.15973 10 7 10C7.84027 10 9.41016 7.60684 10 7M7 9L7 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    //       <path d="M4 13L4 14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    //     </svg>,
    //   callback: () => handleDownloadTemplate(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    fetchGlobalDbnTaxonomyDomains();
  }

  const handleUploadDomainClick = () => {
    dispatch(settings.set({ getUploadModal: 'open' }))
  };

  const handleDelete = async (data: any) => {
    await dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'delete' }))
    await dispatch(globalDbnTaxonomyDomains.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/delete`,
      entity: 'globalDbnTaxonomyDomains',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.GlobalDBNDomainId
          }
        ]
      }
    })).then(() => {
      fetchGlobalDbnTaxonomyDomains();
    });
  }

  const handleUploadClick = async (data: any) => {
    const frmData = new FormData();
    frmData.append(
      'formFile',
      data
    );
    await dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'uploadCreate' }))
    await dispatch(globalDbnTaxonomyDomains.uploadCreate({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/upload-global-dbn-domains`,
      entity: 'uploadDomains',
      jsonData:
        frmData
    })).then(() => {
      toast.info(
        'Domains uploading is in progress',
      );
      handleUploadClose()
    }).then(() => {
      fetchGlobalDbnTaxonomyDomains();
    })
  };

  const handleUploadClose = () => {
    dispatch(settings.set({ getUploadModal: 'close' }))
  }

  useEffect(() => {
    const searchCriteria: any = listGlobalDbnTaxonomyDomainData?.result?.items
      ?.filter((item: any) => item?.Message?.SpecificationAttributeName) // Filter out items with falsy SpecificationAttributeName
      ?.map((item: any) => ({
        FieldName: item.Message.SpecificationAttributeName,
      }));
    setSearchCriteriaList(searchCriteria)
  }, [listGlobalDbnTaxonomyDomainData]);

  useEffect(() => {
    if (createGlobalDbnTaxonomyDomainData?.isSuccess) {
      dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'create' }))
      toast.info('Domain created successfully.')
    }
  }, [createGlobalDbnTaxonomyDomainData]);

  useEffect(() => {
    if (updateGlobalDbnTaxonomyDomainData?.isSuccess) {
      dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'update' }))
      toast.info('Domain updated successfully.')
    }
  }, [updateGlobalDbnTaxonomyDomainData]);

  useEffect(() => {
    if (deleteGlobalDbnTaxonomyDomainData?.isSuccess) {
      dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'delete' }))
      toast.info('Domain deleted successfully.')
    }
  }, [deleteGlobalDbnTaxonomyDomainData]);

  useEffect(() => {
    createColumnDefs()
    fetchGlobalDbnTaxonomyDomains()
    dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'create' }))
    dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'uploadCreate' }))
    dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'update' }))
    dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'delete' }))
  }, [pageData, pageSize])

  return (
    <>
      {getUploadModal == 'open' && <UploadCommonModal title='Import Domains' onSubmit={handleUploadClick} handleClose={handleUploadClose} />}
      {listGlobalDbnTaxonomyDomainData?.isLoading ||
        createGlobalDbnTaxonomyDomainData?.isLoading ||
        updateGlobalDbnTaxonomyDomainData?.isLoading ||
        deleteGlobalDbnTaxonomyDomainData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={listGlobalDbnTaxonomyDomainData?.result?.items}
          enableFilter={true}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listGlobalDbnTaxonomyDomainData?.result?.pagination}
          onSearch={handleSearch}
          searchCriteriaList={searchCriteriaList}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="Global ShipX Taxonomy Domains"
        />
      }
    </>
  );
};

export default GlobalShipXTaxonomyDomains;


